import { Navigate } from 'react-router-dom';
import { useAdminStore, usePortalStore } from '../../stores';

export const AdminAuthGuard = ({ children }) => {
  const { isAuthenticated } = useAdminStore();
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

export const PortalAuthGuard = ({ children }) => {
  const { isAuthenticated } = usePortalStore();
  
  if (!isAuthenticated) {
    return <Navigate to="/portal/login" replace />;
  }
  
  return children;
};
